"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getIntegerFromUnknown_1 = __importDefault(require("../../shared/getIntegerFromUnknown"));
let functionTimeOut;
const executeCallbackWithTimeOut = ({ callbacks, executeProcesses, timeMilliSeconds, }) => {
    functionTimeOut = setTimeout(() => {
        executeProcesses(undefined, callbacks.onActivated);
    }, timeMilliSeconds);
};
const debounceBuilder = () => ({ entryVars: { timeMilliSeconds: timeMilliSecondsEntry, }, executeProcesses, callbacks, lastFunctionsOutputs, functionId, }) => {
    try {
        const timeMilliSeconds = (0, getIntegerFromUnknown_1.default)(timeMilliSecondsEntry);
        if (!functionTimeOut) {
            executeCallbackWithTimeOut({
                callbacks,
                executeProcesses,
                timeMilliSeconds,
                lastFunctionsOutputs,
            });
        }
        else {
            clearTimeout(functionTimeOut);
            executeCallbackWithTimeOut({
                callbacks,
                executeProcesses,
                timeMilliSeconds,
                lastFunctionsOutputs,
            });
        }
    }
    catch (error) {
        executeProcesses(functionId, callbacks.onError, `${error}`);
    }
};
exports.default = debounceBuilder;
